import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { IoMdGlobe } from "react-icons/io";
import alFlag from "../assets/albanianFlag.png";
import enFlag from "../assets/engFlag.webp";
import grFlag from "../assets/grFlag.jpg";

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [showFlags, setShowFlags] = useState(false);

  const toggleFlags = () => {
    setShowFlags(!showFlags);
  };

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    setShowFlags(false); // Optionally close the flags after selecting one
  };

  const languageFlags = {
    en: enFlag,
    al: alFlag,
    gr: grFlag,
  };

  return (
    <Container>
      <GlobeIcon onClick={toggleFlags}>
        <IoMdGlobe size={33} />
      </GlobeIcon>
      {showFlags && (
        <FlagsContainer>
          {Object.keys(languageFlags).map((language) => (
            <img
              key={language}
              src={languageFlags[language]}
              alt={language}
              className={`flag-icon ${
                language === i18n.language ? "active" : ""
              }`}
              onClick={() => changeLanguage(language)}
            />
          ))}
        </FlagsContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  margin-top: 5px;
`;

const GlobeIcon = styled.div`
  cursor: pointer;
  /* margin-top: 5px; */
  color: var(--fontPrimaryColor);
  &:hover {
    color: var(--primaryColor);
  }
`;

const FlagsContainer = styled.div`
  display: flex;
  gap: 2px;
  position: absolute;
  top: 100%;
  left: 0;
  /* padding: 4px; */
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  .flag-icon {
    width: 45px;
    cursor: pointer;
    border: 2px solid transparent;
    &.active {
      border: 2px solid blue;
    }
  }
`;

export default LanguageSelector;
